import ProjectResponseResource from "common/resources/Project/ProjectResponseResource";
import { useEffect, useState } from "react";
import PosterService from "services/projects/PosterService";
import { container } from "tsyringe";

const posterService = container.resolve(PosterService);

export const usePoster = (project: ProjectResponseResource) => {
	const [poster, setPoster] = useState<string | null>(null);

	useEffect(() => {
		if (!project.poster?.file) return;

		posterService.getPosterImage(project.id).then((url) => {
			if (!url) return;
			setPoster(URL.createObjectURL(url));
		});
	}, [project]);

	return { poster };
};
